import { render, staticRenderFns } from "./SupplierManager.vue?vue&type=template&id=44a9cd40&scoped=true"
import script from "./SupplierManager.vue?vue&type=script&lang=js"
export * from "./SupplierManager.vue?vue&type=script&lang=js"
import style0 from "./SupplierManager.vue?vue&type=style&index=0&id=44a9cd40&prod&lang=scss&scoped=true"
import style1 from "./SupplierManager.vue?vue&type=style&index=1&id=44a9cd40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a9cd40",
  null
  
)

export default component.exports